module.exports = __webpack_public_path__ + "fonts/fa-v2-light-300.10839702.ttf";